import React from "react";
import { useHistory } from "react-router-dom";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';

const calcularCambio = (venta, proyeccion) => {
    const diferencia = proyeccion - venta;
    const porcentaje = ((diferencia / proyeccion) * 100).toFixed(2);
    let direccion = "";

    if (porcentaje <= 20) {
        direccion = "arriba";
    } else if (porcentaje > 20 && porcentaje <= 40) {
        direccion = "igual";
    } else {
        direccion = "abajo";
    }

    return { porcentaje, direccion };
};

export const DashboardHeader = ({ data, permisos }) => {
    const ventaneta = data?.estadoresultadoreal?.ventaneta;
    const costos = data?.estadoresultadoreal?.costos;
    const utilidadbruta = data?.estadoresultadoreal?.utilidadbruta;
    const ventanetaproyectada = data?.estadoresultadoproyectado?.ventanetaproyectada;
    const costosproyectados = data?.estadoresultadoproyectado?.costosproyectados;
    const utilidadbrutaproyectada = data?.estadoresultadoproyectado?.utlidadbrutaproyectada;
    const history = useHistory();
    const handleClickEstadoResultado = () => {
        history.push("/Finanzas/EstadodeResultados", permisos);
    };
    const { porcentaje: porcentajeVentasNetas, direccion: direccionVentasNetas } = calcularCambio(ventaneta, ventanetaproyectada);
    const { porcentaje: porcentajeCostos, direccion: direccionCostos } = calcularCambio(costos, costosproyectados);
    const { porcentaje: porcentajeUtilidad, direccion: direccionUtilidad } = calcularCambio(utilidadbruta, utilidadbrutaproyectada);
    const formatmiles = (number) => {
        return Math.floor((number ?? 0) / 1000).toLocaleString('en-US');
    };

    return (
        <div className="dashboard-header-informacion">
            <div className="dashboard-header-informacion-ventas-netas" onClick={handleClickEstadoResultado}>
                <div className="dashboard-header-informacion-title">Ventas Netas</div>
                <div className="dashboard-header-informacion-cantidad">$ {formatmiles(ventaneta)}</div>
                <div className="dashboard-header-informacion-footer">
                    <div className={`change-indicator ${direccionVentasNetas}`}>
                        {direccionVentasNetas === "arriba" && <KeyboardArrowUpIcon />}
                        {direccionVentasNetas === "abajo" && <KeyboardArrowDownIcon />}
                        {direccionVentasNetas === "igual" && <HorizontalRuleIcon />}
                    </div>
                    Proyección ${formatmiles(ventanetaproyectada)} | {porcentajeVentasNetas}%
                </div>
            </div>
            <div className="dashboard-header-informacion-costos" onClick={handleClickEstadoResultado}>
                <div className="dashboard-header-informacion-title">Costos</div>
                <div className="dashboard-header-informacion-cantidad">$ {formatmiles(costos)}</div>
                <div className="dashboard-header-informacion-footer">
                    <div className={`change-indicator ${direccionCostos}`}>
                        {direccionCostos === "arriba" && <KeyboardArrowUpIcon />}
                        {direccionCostos === "abajo" && <KeyboardArrowDownIcon />}
                        {direccionCostos === "igual" && <HorizontalRuleIcon />}
                    </div>
                    Proyección ${formatmiles(costosproyectados)} | {porcentajeCostos}%
                </div>
            </div>
            <div className="dashboard-header-informacion-utilidad" onClick={handleClickEstadoResultado}>
                <div className="dashboard-header-informacion-title">Utilidad Bruta</div>
                <div className="dashboard-header-informacion-cantidad">$ {formatmiles(utilidadbruta)}</div>
                <div className="dashboard-header-informacion-footer">
                    <div className={`change-indicator ${direccionUtilidad}`}>
                        {direccionUtilidad === "arriba" && <KeyboardArrowUpIcon />}
                        {direccionUtilidad === "abajo" && <KeyboardArrowDownIcon />}
                        {direccionUtilidad === "igual" && <HorizontalRuleIcon />}
                    </div>
                    Proyección ${formatmiles(utilidadbrutaproyectada)} | {porcentajeUtilidad}%
                </div>
            </div>
        </div>
    );
};
